
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from "@mui/material";

import CurrencyCell from "../../../component/CurrencyCell";

export default function WGRTotals({
  shop,
  totals,
}) {
  return (
    <TableContainer>
    <Table size="small">
      <TableBody>
        <TableRow
          sx={{
            bgcolor: "primary.light",
            "& td": {
              fontWeight: 700,
              borderTop: "2px solid",
              borderColor: "primary.main",
            },
          }}
        >
          <TableCell>
            Shop {shop}  Total
          </TableCell>

          <TableCell align="right">
            <CurrencyCell
              value={totals.highlyskilledtime}
            />
          </TableCell>

          <TableCell align="right">
            <CurrencyCell
              value={totals.highlyskilledcost}
            />
          </TableCell>

          <TableCell align="right">
            <CurrencyCell
              value={totals.skilledtime}
            />
          </TableCell>

          <TableCell align="right">
            <CurrencyCell
              value={totals.skilledcost}
            />
          </TableCell>

          <TableCell align="right">
            <CurrencyCell
              value={totals.semiskilledtime}
            />
          </TableCell>

          <TableCell align="right">
            <CurrencyCell
              value={totals.semiskilledcost}
            />
          </TableCell>

          <TableCell align="right">
            <CurrencyCell
              value={totals.unskilledtime}
            />
          </TableCell>

          <TableCell align="right">
            <CurrencyCell
              value={totals.unskilledcost}
            />
          </TableCell>

          <TableCell align="right">
            <CurrencyCell
              value={totals.oncostlabour}
            />

            </TableCell>


           <TableCell align="right">
            <CurrencyCell
              value={totals.oncoststore}
            />
            
          </TableCell>


        </TableRow>
      </TableBody>
    </Table>
    </TableContainer>
  );
}

